module.exports = __webpack_public_path__ + "img/1.00c333cd.svg";